import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useParams} from "react-router-dom";
import {useStores} from "../../../stores/Context";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from "@material-ui/core";
import {Button} from "react-bootstrap";
import moment from "moment";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {data} from "autoprefixer";
import ParametresObjectifsDate from "./ParametresObjectifsDate";
import BtnPrimary from "../../../boiteAOutils/BtnPrimary";
import BtnSecondary from "../../../boiteAOutils/BtnSecondary";



const ParametresObjectifs = () => {
    const {ent} = useParams();
    const {widgetStore} = useStores();
    const ModalObject = withReactContent(Swal);
    axios.defaults.headers.common['Authorization'] = 'Bearer '+widgetStore.getCookie("current_apiToken");

    const [listObjectifs, setListObjectifs] = useState('');
    const [newListeObj, setNewListeObj] = useState('');
    const [openAddObj, setOpenAddObj] = useState(false);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL +'/api/getListObjectifsTotem/'+ widgetStore.idTotem)
            .then(response => {
                setListObjectifs(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);


    function ModalSetObjectif(props){
        if (props){
            axios.get(process.env.REACT_APP_API_URL +'/api/objectif/edit/'+ props.data.id)
                .then(response => {
                    console.log(response.data)
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }

        return (
            <div>
               azerty
            </div>
        )
    }

    const verifyNameListeObjt = async (val) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + '/api/objectif/ifLibExist?lib=' + val);
            return response.data.nb === 1;
        } catch (error) {
            console.error('Error fetching data:', error);
            return false;  // ou une autre valeur par défaut appropriée
        }
    }


    function ModalInfoObjectifs(props) {
        console.log('Modal', props.data)
        const [name, setName] = useState(props.data.name ?? '');
        const [nameExiste, setNameExiste] = useState(true);

      //  const handleChandeName = (val) => {
      //      axios.get(process.env.REACT_APP_API_URL +'/api/objectif/ifLibExist?lib='+ val)
      //          .then(response => {
      //              console.log(response.data)
      //              setName(val)
      //              if (response.data.nb === 1){
      //                  setNameExiste(true)
      //              }
      //              else {
      //                  setNameExiste(false)
      //              }
      //          })
      //          .catch(error => {
      //              console.error('Error fetching data:', error);
      //          });
      //  }

        const handleChangeName = async (val) => {
            const verif = await verifyNameListeObjt(val);
            console.log('verifyNameListeObjt', verif)
            setName(val)
            if (verif) {
                setNameExiste(true)
            } else {
                setNameExiste(false)
            }
        }



        return (
            <div style={{marginTop: "2em"}}>

                {
                    nameExiste  ? (<span>Le non existe déja</span>) : null
                }

                <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <span style={{marginRight: "1em"}}>Nom de la liste </span>
                    <TextField variant={"outlined"} value={name} onChange={(e) => handleChangeName(e.target.value)}/>
                </div>

                <div style={{display: "flex", justifyContent: "space-between", marginTop: "2em"}}>
                    {
                        nameExiste === false ? (
                            <Button variant={"success"} >Modifier</Button>
                        ) : null
                    }
                    <Button variant={"secondary"} onClick={()=> ModalObject.close()}>Annuler</Button>
                </div>

            </div>

        )

    }

    const handleAddObjectif = (data) => {
        ModalObject.fire({
            width: 800,
            allowOutsideClick: false,
            html: <ParametresObjectifsDate data={data} ent={localStorage.getItem(ent)}/>,
            showDenyButton: false,
            showCancelButton: false,
            showConfirmButton: false
        })
    }
    
    const handleEditObjectif = (data) => {
        ModalObject.fire({
            title: "Edition d'une liste d'objectifs",
            width: 800,
            allowOutsideClick: false,
            html: <ModalInfoObjectifs data={data} />,
            showDenyButton: false,
            showCancelButton: false,
            showConfirmButton: false
        })
    }

    return (
        <div style={{width: "53%"}}>
            <div className={"parametreContentTitre"}>
                <h4 className={"parametreTitre4"}>Objectifs</h4>
            </div>

            <div className={"parametreObjectifsListeContent"}>
                {
                    listObjectifs ? (
                        listObjectifs.map((data) => (
                            <div className={"parametreObjectifsListeItems"}>
                                <h4 className={"parametreObjectifsListeName"}>{data.name}</h4>
                                <div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M3.11837 13.1279L14.7162 1.53009C14.735 1.52442 14.7556 1.51852 14.7777 1.51253C14.9366 1.46948 15.1659 1.42467 15.4349 1.42096C15.9531 1.41381 16.6406 1.55486 17.3159 2.23014C17.9912 2.90543 18.1323 3.59298 18.1251 4.11115C18.1214 4.3802 18.0766 4.60948 18.0335 4.7684C18.0276 4.7905 18.0217 4.81104 18.016 4.82992L6.4182 16.4277L2.6684 16.8777L3.11837 13.1279Z"
                                            stroke="#002335" strokeWidth="2"/>
                                        <path d="M11.8887 2.94336L16.3782 7.43293" stroke="#002335" strokeWidth="2"/>
                                    </svg>
                                </div>
                                <div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M3.30809 16.1505L2.71726 4.33398H17.2814L16.6906 16.1505C16.6108 17.7471 15.293 19.0007 13.6944 19.0007H6.30435C4.70572 19.0007 3.38792 17.7471 3.30809 16.1505Z"
                                            stroke="#F82121" strokeWidth="2"/>
                                        <path
                                            d="M6.83398 4H13.1673V3C13.1673 1.89543 12.2719 1 11.1673 1H8.83399C7.72942 1 6.83398 1.89543 6.83398 3V4Z"
                                            stroke="#F82121" strokeWidth="2"/>
                                        <path d="M0.833984 4.16602H19.1673" stroke="#F82121" strokeWidth="2"/>
                                        <path d="M12.5 9.16602V13.3327" stroke="#F82121" strokeWidth="2"/>
                                        <path d="M7.5 9.16602V13.3327" stroke="#F82121" strokeWidth="2"/>
                                    </svg>
                                </div>
                            </div>

                        ))
                    ) : null
                }


                {
                    /*
                    <div style={{display: "flex", alignItems: "center", width: "75%", marginBottom: "2em"}}>
                    <input className={"parametreInput"} type={"text"}/>
                    <Button variant={"secondary"}>Ajouter une liste d'objectifs</Button>
                </div>


                <TableContainer component={Paper} style={{width: "75%"}}>
                    <Table sx={{minWidth: 650}}>
                        <TableHead>
                            <TableRow style={{fontWeight: "bold"}}>
                                <TableCell>Nom</TableCell>
                                <TableCell>Date création</TableCell>
                                <TableCell>Date Modification</TableCell>
                                <TableCell align={"center"}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                listObjectifs ? (
                                    listObjectifs.map((data) => (
                                        <TableRow>
                                            <TableCell>{data.name}</TableCell>
                                            <TableCell>{moment(data.created_at).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell>{moment(data.updated_at).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell>
                                                <Button variant={"info"}
                                                        onClick={() => handleEditObjectif(data)}>Modifier</Button>
                                                <Button variant={"info"} onClick={() => handleAddObjectif(data)}>Ajouter
                                                    des objectifs</Button>
                                                <Button variant={"danger"}>Supprimer</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : null

                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                     */
                }

            </div>


            {
                openAddObj ? (
                    <div>
                        <div className={"parametreObjectifLabelContent"}>
                            <span className={"parametreObjectifLabel"}>Titre de l'objectif :</span>
                            <input type={"text"} className={"parametreObjectifInputTitre"}
                                   placeholder={"Titre de l'objectif"}/>
                        </div>
                        <div className={"parametreObjectifLabelContent2"}>
                            <div className={"parametreObjectifObjContent"}>
                                <span className={"parametreObjectifLabel"}>Date de début :</span>
                                <input type={"date"} className={"parametreObjectifInputDate"}/>
                            </div>
                            <div className={"parametreObjectifObjContent"}>
                                <span className={"parametreObjectifLabel"}>Objectifs :</span>
                                <input type={"text"} className={"parametreObjectifInputObj"}/>
                            </div>
                        </div>

                        <div className={"parametreObjectifLabelContent2"}>
                            <div className={"parametreObjectifObjContent"}>
                                <span className={"parametreObjectifLabel"}>Date changement :</span>
                                <input type={"date"} className={"parametreObjectifInputDate"}/>
                            </div>
                            <div className={"parametreObjectifObjContent"}>
                                <span className={"parametreObjectifLabel"}>Objectifs :</span>
                                <input type={"text"} className={"parametreObjectifInputObj"}/>
                            </div>
                        </div>

                        <button type={"button"} className={"parametreObjectifsNexOjtBtn"}>+ Ajouter un changement
                            d'objectif
                        </button>

                        <div className={"parametreObjectifLabelContent2"}>
                            <div className={"parametreObjectifObjContent"}>
                                <span className={"parametreObjectifLabel"}>Date de fin :</span>
                                <input type={"date"} className={"parametreObjectifInputDate"}/>
                            </div>
                            <div className={"parametreObjectifObjContent"}>
                                <span className={"parametreObjectifLabel"}>Objectifs :</span>
                                <input type={"text"} className={"parametreObjectifInputObj"}/>
                            </div>
                        </div>

                        <div className={"parametreObjectifNewBtnContent"}>
                            <BtnSecondary onClick={() => setOpenAddObj(false)}>Annuler</BtnSecondary>
                            <BtnPrimary onClick={() => alert("to do")}>Ajouter l'objectif</BtnPrimary>
                        </div>

                    </div>
                ) : (
                    <button type={"button"} className={"parametreObjectifsNexOjtBtn"}
                            onClick={() => setOpenAddObj(true)}>+ Ajouter un nouvel objectif</button>
                )
            }


        </div>
    );
};

export default ParametresObjectifs;